<template>
  <div>
    <div class="cards flex flex-between">
	  <div class="card" v-for="(item, index) in amountList" :key="item.id" @click="selectAmount(item)" :class="{selected:isSelected == item.id}">
	   <span>${{ item.amount }}</span>
	  </div>
	  <!-- <div class="card selected"><span>$150</span></div> -->
    </div>

    <div class="custom-amount">

      <h3>Custom Amount</h3>
      <div class="flex flex-center">
        <span>$</span>
        <input type="number" v-model="amount" placeholder="Enter your custom amount">
        <span>.00</span>
      </div>

      <div class="inputs flex flex-center">
        <div>
          <input type="email" v-model="email"  placeholder="Email Address" required>
          <span>*required</span>
        </div>
        <div>
          <input type="text" v-model="phone"  placeholder="Phone Number" required>
          <span>*required</span>
        </div>
      </div>
      <div class="inputs flex flex-center">
        <div class="message">
          <input type="text" placeholder="Message">
        </div>
      </div>
      <div class="inputs flex flex-center checkbox-subs">
        <input type="checkbox" v-model="subscribe" ><span>Sign me up to the Monte Cecilia supporters' newsletter</span>
      </div>
      <div class="error-message" v-if="errorMessage">{{ errorMessage }}</div>
      <button @click="pay()" :disabled="loading">{{ buttonName }}</button>


    </div>
  </div>
</template>
<script>
export default {
  props: {
    amountList: Array,
    module_type: Number
  },

  data () {
    return {
      amount: 0.00,
      email: null,
      phone: null,
      loading: false,
      errorMessage: '',
      buttonName: 'PROCEED',
      isSelected: null,
      subscribe: true,
    }
  },

  methods: {

    selectAmount (item) {
      this.amount = item.amount
        this.isSelected = item.id
    },

    pay () {
      if (!isNaN(this.amount)) {
        if (this.amount > 0) {

          if(this.email && this.phone){

            this.triggerLoading()

            window.axios.post('/api/donations/pay/pxpay', { amount: this.amount, email: this.email, phone: this.phone, subscribe: this.subscribe })
              .then(res => {
                if (res.data.success) {
                  window.location.href = res.data.url
               } else {
                  this.resetWithError(res.data.message)
                }
              })
              .catch(error => {
                this.resetWithError(error.response.data.message)
              })
          } else {
            this.errorMessage = 'Email and Phone Number is required'
            this.buttonName = 'PROCEED'
            this.loading = false
          }
        } else {
          this.errorMessage = 'Donation amount should be greater than 0'
        }
      } else {
        this.errorMessage = 'Donation amount is not a number'
      }
    },

    resetWithError (message) {
      this.errorMessage = message
      this.buttonName = 'PROCEED'
      this.loading = false
    },

    triggerLoading () {
      this.errorMessage = ''
      this.buttonName = 'loading'
      this.loading = true
    }

  }
}
</script>

<style scoped>
  .checkbox-subs {
    gap: 10px !important;
  }
  .checkbox-subs input {
      width: 23px !important;
      margin-right: 0 !important;
  }
  .checkbox-subs span {
      padding-bottom: 10px !important;
      font-size: 18px !important;
      font-weight: 400 !important;
  }
</style>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/WindCave.vue